import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { SelectedEventArgs } from '@syncfusion/ej2-angular-inputs';
import { EmitType } from '@syncfusion/ej2-base';
import { HttpService } from '../../services/http.service';

@Component({
    selector: 'upload-file-dialog',
    templateUrl: './upload-file-dialog.html',
})
export class UploadFileDialogComponent {
    @ViewChild('dlg') dlg: DialogComponent;
    visible: boolean = false;
    isChanged: boolean = false;
    params: any = null;
    callback: any = null;

    constructor(private http: HttpService) {
    }

    show(params: any, callback) {
        this.params = params;
        this.callback = callback;
        this.dlg.show();
    }

    showEx(path: Object, params: any, callback) {
        this.path = path;
        this.params = params;
        this.callback = callback;
        this.dlg.show();
    }

    public path: Object = {
        saveUrl: `${this.http.getUrl()}api/LinkFile/UploadRequestDoc`,
        removeUrl: 'https://aspnetmvc.syncfusion.com/services/api/uploadbox/Remove'
    };

    public onFileUpload: EmitType<SelectedEventArgs> = (args: any) => {
        args.customFormData = this.params;
    };

    public onUploadSuccess(args: any): void {
        if (args.operation === 'upload') {
            this.isChanged = true;
            console.log('File uploaded successfully');
        }
    }

    onClose(evt: any) {
        if (this.callback != null)
            this.callback();
    }
}
